import { filter } from 'lodash'

import { MarketDetailDto } from '@/gen/publicApi'

import { Input } from '@/components/input'
import { Label } from '@/components/label'

import { fromLocalTime } from '@/utils/time'

import RuleGroups from './ruleGroups'

interface Props {
    market: MarketDetailDto
}

export default function MarketConfig({ market }: Props) {
    const unitRules = filter(market.tickRuleGroups, ['groupType', 'Unit'])
    const priceRules = filter(market.tickRuleGroups, ['groupType', 'Price'])
    return (
        <div>
            {market.timingConfigs && (
                <>
                    <h3 className="mt-4">Timing</h3>
                    {market.timingConfigs.map(config => {
                        return (
                            <div key={config.name}>
                                <h5 className="mb-2 mt-3">{config.name}</h5>
                                <div className="flex space-x-3 pt-2">
                                    <div className="w-1/2">
                                        <Label>Init Time</Label>
                                        <Input value={fromLocalTime(config.initTime)} disabled />
                                    </div>
                                    <div className="w-1/2">
                                        <Label>Down Time</Label>
                                        <Input value={fromLocalTime(config.downTime)} disabled />
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </>
            )}
            <RuleGroups type="unit" ruleGroups={unitRules} />
            <hr className="my-4" />
            <RuleGroups type="price" ruleGroups={priceRules} />
        </div>
    )
}
